import { useRouter } from 'next/router'
import { MapSearchTagsInput as Input } from 'ui-components'
import { getSearchQuery } from 'utils'

import { useTags } from '~map-search/hooks/useTags'

export function MapSearchTagsInput() {
  const router = useRouter()
  const tags = useTags()

  const handleDelete = (id) => {
    router.push(
      getSearchQuery({
        tags: removeTagById(tags, id)
      }),
      undefined,
      { shallow: true }
    )
  }

  return (
    <Input
      options={tags}
      onDelete={handleDelete}
    />
  )
}

function removeTagById(tags, id) {
  return tags.filter((item) => item.id !== id).map((item) => item.id)
}
